import '@algolia/autocomplete-theme-classic'
import React, { useEffect } from "react";
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js'
import { searchClient } from '@/lib/util/client'

const formatSlug = (slug: string) => {
    return slug
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const SearchBar = () => {

    useEffect(() => {
        const autocompleteInstance = autocomplete({
            container: '#autocomplete',
            getSources({ query }) {
                return [
                    {
                        sourceId: 'advice',
                        getItems() {
                            return getAlgoliaResults({
                                searchClient,
                                queries: [
                                    {
                                        indexName: 'advice',
                                        query,
                                    },
                                ],
                            })
                        },
                        templates: {
                            item({
                                item,
                                components,
                                html,
                            }: {
                                item: any
                                components: any
                                html: any
                            }) {
                                const sourceText = item.sourceText || "";
                                const query = item._highlightResult?.sourceText?.matchedWords?.[0] || ""; // Get the first matched query term

                                function getExcerpt(text: string, match: string, charsAround = 200): { prefix: string, match: string, suffix: string, before: string, after: string } {
                                    const index = text.toLowerCase().indexOf(match.toLowerCase());
                                    const start = Math.max(0, index - charsAround);
                                    const end = Math.min(text.length, index + match.length + charsAround);
                                    const prefix = start > 0 ? "..." : "";
                                    const suffix = end < text.length ? "..." : "";

                                    return {
                                        prefix,
                                        match: text.substring(index, index + match.length), // Extract actual matched text
                                        suffix,
                                        before: text.substring(start, index), // Text before match
                                        after: text.substring(index + match.length, end), // Text after match
                                    };
                                }

                                if ((item.slug !== null && (item._type === "category" || (item._type === 'topic' && item.path !== null && item.path.categorySlug !== null) || (item._type === 'article' && item.path !== null && item.path.categorySlug !== null && item.path.topicSlug !== null)))) {
                                    const { prefix, match, suffix, before, after } = getExcerpt(sourceText, query);
                                    const itemTitle = item._type === 'category'
                                        ? formatSlug(item.slug)
                                        : item._type === 'topic'
                                            ? `${formatSlug(item.path.categorySlug)} -> ${formatSlug(item.slug)}`
                                            : `${formatSlug(item.path.categorySlug)} -> ${formatSlug(item.path.topicSlug)} -> ${formatSlug(item.slug)}`
                                    const itemUrl = item._type === 'category'
                                        ? `/${item.slug}`
                                        : item._type === 'topic'
                                            ? `/${item.path.categorySlug}/${item.slug}`
                                            : `/${item.path.categorySlug}/${item.path.topicSlug}/${item.slug}`;

                                    return html`<div class="aa-ItemWrapper">
                                            <div class="aa-ItemContent grid-row">
                                              <a class="aa-ItemLink" href="${itemUrl}">
                                                <div class="flex flex-col gap-1">
                                                  <div class="aa-ItemTitle text-green-900 font-semibold">
                                                    ${itemTitle}
                                                  </div>
                                                  <div class="aa-ItemExcerpt text-slate-600 text-sm leading-snug">
                                                    ${prefix}${before}<mark>${match}</mark>${after}${suffix}
                                                  </div>
                                                </div>
                                              </a>
                                            </div>
                                          </div>`;


                                }
                            },
                        },
                    },
                ]
            },
        })
        return () => {
            if (autocompleteInstance) {
                autocompleteInstance.destroy()
            }
        }
    }, [])
    return (
        <div className="relative z-10 sm:max-w-96 mx-auto">
            <i className="absolute ml-2 text-slate-400">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    />
                </svg>
            </i>
            <div id="autocomplete"></div>
        </div>
    )
}